(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.modelUtil = factory();
  }
}(this, function () {
	function isObject(obj){
		var type = typeof obj;

		return type === 'function' || type === 'object' && !!obj;
	}
	
    return {
		/**
		 * Gets the id of a given input. If the id is an object, its `idAttr` will be returned. Otherwise, the input is returned directly.
		 * @param  {Object|String|Number} modelOrKey The input from which to extract the id.
		 * @param {String} [idAttr:'id'] The name of the attribute containing the ID.
		 * @return {String|Number}            The id of the input.
		 */
		idFor: function(modelOrKey, idAttr){
			idAttr = idAttr || 'id';

			if(isObject(modelOrKey)){
				return modelOrKey[idAttr];
			} else {
				return modelOrKey;
			}
		}
	};
}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@HBKEngineering/model-util/index.js
// module id = 126
// module chunks = 1